var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H101V101H0V0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5567 84.4029L34.2859 79.7253C35.777 82.3691 37.1335 84.606 40.3871 84.606C43.5059 84.606 45.4722 83.386 45.4722 78.6406V46.3687H54.9637V78.7747C54.9637 88.6054 49.2012 93.08 40.794 93.08C33.2012 93.08 28.7937 89.1476 26.5565 84.402",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1191 83.386L67.8473 78.9114C69.8818 82.2338 72.5259 84.6743 77.2036 84.6743C81.1364 84.6743 83.6442 82.708 83.6442 79.9961C83.6442 76.7418 81.0681 75.5891 76.7289 73.6914L74.3567 72.6737C67.5088 69.759 62.9662 66.098 62.9662 58.3689C62.9662 51.2502 68.3899 45.8262 76.8649 45.8262C82.8989 45.8262 87.2379 47.9281 90.3562 53.4198L82.9662 58.1653C81.339 55.2503 79.5768 54.0979 76.865 54.0979C74.0853 54.0979 72.3224 55.8606 72.3224 58.1653C72.3224 61.0129 74.0853 62.1657 78.1527 63.9286L80.5254 64.9455C88.5934 68.4034 93.136 71.9284 93.136 79.8604C93.136 88.4034 86.4241 93.081 77.4072 93.081C68.5936 93.081 62.8985 88.8778 60.1192 83.386",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.936464180fe6c95d208a26725c598612.svg";
export { ForwardRef as ReactComponent };